var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArticle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1862_15770",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1862_15770)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.5 137.501H112.5V129.167H62.5V137.501ZM62.5 104.167H137.5V95.834H62.5V104.167ZM62.5 70.834H137.5V62.5007H62.5V70.834ZM46.7948 166.667C42.9594 166.667 39.7569 165.383 37.1875 162.813C34.618 160.244 33.3333 157.041 33.3333 153.206V46.7954C33.3333 42.96 34.618 39.7576 37.1875 37.1882C39.7569 34.6187 42.9594 33.334 46.7948 33.334H153.205C157.041 33.334 160.243 34.6187 162.812 37.1882C165.382 39.7576 166.667 42.96 166.667 46.7954V153.206C166.667 157.041 165.382 160.244 162.812 162.813C160.243 165.383 157.041 166.667 153.205 166.667H46.7948ZM46.7948 158.334H153.205C154.487 158.334 155.662 157.8 156.731 156.731C157.799 155.663 158.333 154.488 158.333 153.206V46.7954C158.333 45.5135 157.799 44.3383 156.731 43.2698C155.662 42.2015 154.487 41.6673 153.205 41.6673H46.7948C45.5128 41.6673 44.3376 42.2015 43.2691 43.2698C42.2008 44.3383 41.6666 45.5135 41.6666 46.7954V153.206C41.6666 154.488 42.2008 155.663 43.2691 156.731C44.3376 157.8 45.5128 158.334 46.7948 158.334Z",
    fill: "#046AD0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticle);
export default __webpack_public_path__ + "static/media/article.17b4b44f64cfa1fad87caafc8c94bbed.svg";
export { ForwardRef as ReactComponent };